import styled, { createGlobalStyle } from 'styled-components';

import { ToastContainer as ReactToastContainer } from 'react-toastify';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }
  body {
    background: ${props => props.theme.colors.secondary};
    color: ${props => props.theme.colors.primaryText};
    -webkit-font-smoothing: antialiased;
  }
  body, input, button {
    font-family: 'Roboto', serif;
    font-size: 16px;
  }
  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 500;
  }
  button {
    cursor: pointer;
  }

  .Toastify__toast-body {
    overflow: hidden;
    font-size: 1rem;
  }
  .Toastify__toast--warning {
    color: black
  }
`;

export const ToastContainer = styled(ReactToastContainer).attrs({
  hideProgressBar: true,
  closeOnClick: true,
})`
  border-radius: 10px;
`;
